var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");
var drawSymbolTerminalDataTo2D = require("./../renderData/drawSymbolTerminalDataTo2D");

var drawSymbolDescriptionTo2D = function (svg, defaultGroup, groups, dataKey, description, includeTerminals) {
   

    ////////// NExt TODO: fix this.  its hardcoded.  !! /Chris
    var g = svg.group(defaultGroup);
    var g1 = svg.group(groups[0]);
    description.shapes.forEach(function(idx, element) {
         if(element instanceof cio_datamodel.TextData || element instanceof cio_datamodel.PropertyData){
            editor_2d.drawShapeDataTo2D(svg, g1, element);
         } else {
            editor_2d.drawShapeDataTo2D(svg, g, element);
         }

    });
    /////////
 
    if (includeTerminals){
        description.terminals.forEach(function(idx, terminal) {
            drawSymbolTerminalDataTo2D(svg, g, terminal, includeTerminals);
        });
    }
	return g + g1;
};

module.exports = drawSymbolDescriptionTo2D;
